"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seCompanyNumberChecker = void 0;
var ORGANISATIONSNUMMER_REGEX = /^\d{10}$/;
var seCompanyNumberChecker = exports.seCompanyNumberChecker = function seCompanyNumberChecker(companyNumber) {
  return ORGANISATIONSNUMMER_REGEX.test(companyNumber);
};